import { render, staticRenderFns } from "./waterAdd.vue?vue&type=template&id=f37c5bbc&scoped=true&"
import script from "./waterAdd.vue?vue&type=script&lang=js&"
export * from "./waterAdd.vue?vue&type=script&lang=js&"
import style0 from "./waterAdd.vue?vue&type=style&index=0&id=f37c5bbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37c5bbc",
  null
  
)

export default component.exports